// extracted by mini-css-extract-plugin
export default {"input":"styles_input__2WIl8","select":"styles_select__Y5a9Z","btn_add":"styles_btn_add__M2Q5r","active_btn":"styles_active_btn__KxPFB","selectList":"styles_selectList__agUHm"};